import { defineMessages } from '@dragonraider5/react-intl'

import {
  FINANCIAL_TYPES_VALUES,
  HOW_RETURN_VALUES
} from '../../constants'

export default defineMessages({
  [`financialTypes${FINANCIAL_TYPES_VALUES.hipoteca}`]: {
    id: 'containers.Applications.steps.forms.financialTypes.values.hipotecas',
    description: 'Financial type text for hipotecas values',
    defaultMessage: 'Préstamo garantía hipotecaria'
  },
  [`financialTypes${FINANCIAL_TYPES_VALUES.personal}`]: {
    id: 'containers.Applications.steps.forms.financialTypes.values.personal',
    description: 'Financial type text for personal values',
    defaultMessage: 'Préstamo personal'
  },
  [`financialTypes${FINANCIAL_TYPES_VALUES.anticipo}`]: {
    id: 'containers.Applications.steps.forms.financialTypes.values.anticipo',
    description: 'Financial type text for anticipo values',
    defaultMessage: 'Préstamo anticipo'
  },
  [`financialTypes${FINANCIAL_TYPES_VALUES.descuento}`]: {
    id: 'containers.Applications.steps.forms.financialTypes.values.descuento',
    description: 'Financial type text for descuento values',
    defaultMessage: 'Línea de descuento'
  },
  [`financialTypes${FINANCIAL_TYPES_VALUES.credito}`]: {
    id: 'containers.Applications.steps.forms.financialTypes.values.credito',
    description: 'Financial type text for credito values',
    defaultMessage: 'Línea de crédito'
  },
  [`financialTypes${FINANCIAL_TYPES_VALUES.avales}`]: {
    id: 'containers.Applications.steps.forms.financialTypes.values.avales',
    description: 'Financial type text for avales values',
    defaultMessage: 'Avales'
  },
  [`howReturn${HOW_RETURN_VALUES.cajaFutura}`]: {
    id: 'containers.Applications.steps.forms.howReturn.values.cajaFutura',
    description: 'How return text for cajaFutura value',
    defaultMessage: 'Con caja futura de la que estoy seguro'
  },
  [`howReturn${HOW_RETURN_VALUES.financiacionFlujo}`]: {
    id: 'containers.Applications.steps.forms.howReturn.values.financiacionFlujo',
    description: 'How return text for financiacionFlujo value',
    defaultMessage: 'Esta financiación me va a dar flujo concreto'
  },
  [`howReturn${HOW_RETURN_VALUES.flujoProbable}`]: {
    id: 'containers.Applications.steps.forms.howReturn.values.flujoProbable',
    description: 'How return text for flujoProbable value',
    defaultMessage: 'Con flujos de caja futuros probables'
  },
  // [`howReturn${HOW_RETURN_VALUES.flujoPosible}`]: {
  //   id: 'containers.Applications.steps.forms.howReturn.values.flujoPosible',
  //   description: 'How return text for flujoPosible value',
  //   defaultMessage: 'Con flujos de caja futuros posibles'
  // },
  [`howReturn${HOW_RETURN_VALUES.otros}`]: {
    id: 'containers.Applications.steps.forms.howReturn.values.otros',
    description: 'How return text for otros value',
    defaultMessage: 'Otros'
  },
  howMuchTimeMonthsTip: {
    id: 'containers.Applications.steps.forms.howMuchTimeMonths.tip',
    description: 'How return text for otros value',
    defaultMessage:
      `Triodos Bank establece un plazo máximo de {productType, select,
        1 { 15 años }
        2 { 7 años }
        3 { 3 años}
        4 { 1 año }
        5 { 1 año }
      } para {productType, select,
        1 { el préstamo de garantía hipotecaria escogido}
        2 { el préstamo personal escogido}
        3 { el préstamo de anticipo escogido}
        4 { la línea de descuento escogida}
        5 { la línea de crédito escogida}
      }. Si necesitas un plazo superior lo podrás comunicar a la entidad una vez contactemos contigo. Indica el plazo máximo en función del tipo de producto y continúa con el proceso.`
  }
})
